<template>
    <el-dialog
        class="recharge"
        :visible.sync="rechargeVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Recharge"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="rechargeForm"
                :model="rechargeForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Current Balance"
                            size="small"
                        >
                            <span class="recharge-num"
                                >$ {{ currentBalance }}</span
                            >
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item size="small">
                            <el-radio-group
                                v-model="rechargeForm.amount"
                                size="medium"
                                @change="amountChange"
                            >
                                <el-radio-button
                                    v-for="item in amountList"
                                    :key="item"
                                    :label="item"
                                ></el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="17">
                        <el-form-item
                            label="Amount"
                            size="small"
                        >
                            <el-input
                                clearable
                                placeholder=""
                                maxlength="200"
                                size="small"
                                v-model="rechargeForm.num"
                                @change="changeAmount"
                            >
                                <i slot="prefix">$</i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="17">
                        <el-form-item label="Relation No." size="small">
                            <el-input
                                clearable
                                placeholder=""
                                maxlength="200"
                                size="small"
                                v-model="rechargeForm.relation_no"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="17">
                        <el-form-item
                            label="Remark"
                            size="small"
                        >
                            <el-input
                                clearable
                                placeholder=""
                                maxlength="200"
                                size="small"
                                v-model="rechargeForm.remark"
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 6 }"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Recharge</el-button
            >
            <el-button size="small" @click="rechargeVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            currentBalance: "0.00",
            rechargeForm: {
                num: "",
                relation_no: "",
                remark: "",
                amount: "",
            },
            payMethod: 'paypal',
            checked: false,
            amountList: [1000, 3000, 5000],
        };
    },
    methods: {
        amountChange(val) {
            this.rechargeForm.num = val;
        },
        changeAmount() {
            !this.amountList.includes(this.rechargeForm.num)
                ? (this.rechargeForm.amount = this.rechargeForm.num)
                : (this.rechargeForm.amount = "");
        },
        save() {
            this.$confirm("Confirm to recharge?", "recharge", {
                type: "warning",
            }).then(() => {
                this.loading = true;
                cmofferApi.recharge(
                    {
                        amount: this.rechargeForm.num,
                        admin_pay: this.tableItem.id,
                        relation_no: this.rechargeForm.relation_no,
                        remark: this.rechargeForm.remark,
                        pay_method: 'balance'
                    },
                    "post"
                )
                .then((res) => {
                    this.loading = false;
                    this.closeDialog();
                    this.$parent[this.funcName]();
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                });
            }).catch(() => {
                this.$message.info("Recharge failed!");          
            });


            
        },
        getEntityInfo() {
            cmofferApi.entityInfo({}, "get").then((res) => {
                if (res) {
                    this.currentBalance = res.data.balance;
                }
            });
        },
        closeDialog() {
            this.rechargeForm = {
                num: "",
                remark: "",
                amount: "",
            };
            this.$emit("update:rechargeVisible", false);
        },
        async initialize() {
            // this.getEntityInfo();
        },
    },
    props: {
        rechargeVisible: Boolean,
        tableItem: Object,
        funcName: String
    },
    watch: {
        rechargeVisible() {
            if (this.rechargeVisible) {
                console.log('this.tableItem: ', this.tableItem);
                this.currentBalance = this.tableItem.balance;
                this.initialize();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.recharge {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }

        .el-select {
            width: 100%;
        }

        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
    .recharge-num {
        font-size: 18px;
        font-weight: 600;
    }
    .rm-method {
        margin-top: 20px;
        ::v-deep .el-radio-group {
            width: 100%;
            .el-radio {
                display: flex;
                align-items: center;
                padding: 4px 10px;
                box-sizing: border-box;
                border: 1px solid #e1e2e3;
                font-size: 16px;
                min-height: 40px;
                background-color: #ffffff;
                margin-right: 0;
                .el-radio__label {
                    span {
                        margin-left: 5px;
                    }
                }
                & + .el-radio {
                    margin-top: 10px;
                }
                &.is-checked {
                    border-color: $color-primary-blue;
                }
            }
        }
    }
}
</style>
